import VersionManagerCore from '../versionManager.js';
import { pgVersionManager } from '../proGalleryVersionManager';
var SettingsVersionManager = /** @class */ (function () {
    function SettingsVersionManager(proGallertVersionManager) {
        this.pgVersionManager = proGallertVersionManager || pgVersionManager;
    }
    SettingsVersionManager.prototype.newMobileSettings = function () {
        return (this.pgVersionManager.getVersion('settings') !==
            VersionManagerCore.Versions.min);
    };
    return SettingsVersionManager;
}());
export default new SettingsVersionManager();
//# sourceMappingURL=settings.js.map